







import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitPositionData } from '@/api/heritageUnit/unitBase'
import UnitMap from '@/components/unitMap/index.vue'
import ViewDialog from '@/components/dialog/viewDialog.vue'
import { CheckPointData, UnitPositionMapData } from '@/api/common/mapData'

@Component({
  components: {
    ViewDialog, UnitMap
  }
})
export default class PointInMap extends Vue {
  public showDialog: boolean = false
  @Prop({ default: '' })
  public unitName!: string
  public $refs!: {
    refUnitMap: UnitMap
  }
  public mounted() {
    window.eventBus.$on('openUnitCoordPreview', (data: { points: UnitPositionData[], unitId: number, mapTitle: string }) => {
      if (data.mapTitle && data.mapTitle != '') {
        this.unitName = data.mapTitle
      }
      this.loadData(data.points, data.unitId)
    })
    window.eventBus.$on('openCameraCoordPreview', (data: { points: any[], title: string }) => {
      const mapData: {
        checkPoint: CheckPointData
        positions: UnitPositionMapData[]
        tracks: any
        obj: any
      } = {
        checkPoint: new CheckPointData(),
        positions: [],
        tracks: [],
        obj: { unitName: data.title, videos: data.points }
      }
      this.showDialog = true
      this.$nextTick(() => {
        if (this.$refs.refUnitMap) {
          this.$refs.refUnitMap.loadData(mapData)
        }
      })
    })
  }
  public loadData(data: UnitPositionData[], unitId: number) {
    this.showDialog = true
    //这句没用，会记录上次的数据，导致下面添加建控地带的坐标的时候会出现多个文保单位的坐标都添加到一起了
    let p: UnitPositionMapData[] = data.map((e: UnitPositionData) => {
      return {
        UnitId: unitId,
        IsPart: false,
        Category: e.PositionType,
        Title: e.PositionName,
        Longitude: e.HeritageLongitude,
        Latitude: e.HeritageLatitude
      }
    })
    this.$nextTick(() => {
      this.loadMap(p)
    })
  }

  public loadMap(p: UnitPositionMapData[]) {
    const data: {
      checkPoint: CheckPointData
      positions: UnitPositionMapData[]
      tracks: any
      obj: any
    } = {
      checkPoint: new CheckPointData(),
      positions: p,
      tracks: [],
      obj: { unitName: this.unitName }
    }
    if (this.$refs.refUnitMap) {
      this.$refs.refUnitMap.loadData(data)
    }
    // window.eventBus.$emit('loadUnitMap', mapData)
  }
  public beforeDestroy() {
    if (this.$refs.refUnitMap) {
      this.$refs.refUnitMap.closeMap()
    }
    this.showDialog = false
    window.eventBus.$off('openUnitCoordPreview')
    window.eventBus.$off('openCameraCoordPreview')
  }
  public closeDialog() {
    this.showDialog = false
  }
}
